export default {
    users: {},
    startDate: null,
    endDate: null,
    filteredCampaigns: [],
    filteredLeadTypes: [],
    viewId: null,
    notificationDate: null,
    selectedDashboardView: null,
    dashboardViews: {},
    configs: {
        hotSwapDate: null,
        currentView: {
            hotSwapDate: null,
        },
        dates: [],
        columnVisibilities: {},
        columns: {},
        filters: {},
        order: {
            orderBy: 'fullname',
            sortBy: 'asc',
        },
        expanded: {
            leadTable: true,
            saleProfit: false,
            saleTable: false,
            statsByAgent: true,
            tradeReport: false,
            userTable: false,
            statsTable: false,
        },
        options: {
            carryOver: true,
            doubleWalkIn: false,
            endContractStats: false,
            phoneAppointment: false,
            recordedDate: false,
            resultStats: false,
            showAgent: true,
            showAllLeads: false,
            showStats: true,
            homeVisit: false,
            lostDate: false,
        },
    },
    pagination: {
        currentPage: undefined,
        lastPage: undefined,
        perPage: undefined,
        from: undefined,
        to: undefined,
        total: undefined,
        orderBy: 'date',
        sortBy: 'desc',
    },
    dashboardType: '',
    filters: {},
    filterApplied: false,
    bulkSelect: [],
    blackListedLeadIds: [],
    allLeadsInTableSelected: false,
    filteredDates: [],
    startContractDate: null,
    tableLeads: [],
    storedStartDate: null,
    storedEndDate: null,
    sharedDashboardViews: {},
};
